import request from "@/utils/request";

// 获取管制时间规则列表
export function getPageList(data) {
  return request({
    url: "/open/restriction/timeRule/page",
    method: "post",
    data: data
  });
}

// 创建管制时间规则
export function create(data) {
  return request({
    url: "/open/restriction/timeRule/create",
    method: "post",
    data: data
  });
}

// 修改管制时间规则
export function update(data) {
  return request({
    url: "/open/restriction/timeRule/update",
    method: "post",
    data: data
  });
}

// 删除管制时间规则
export function deleteRule(data) {
  return request({
    url: "/open/restriction/timeRule/delete",
    method: "post",
    data: data
  });
}